import { CompanyOptionModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';

const defaultCompanyOptionModelDto: CompanyOptionModelDto = {
    name: '',
    value: '0',
};

export class PositivePayOption extends DomainEntity<CompanyOptionModelDto> {
    public createDefault(): this {
        return new PositivePayOption(defaultCompanyOptionModelDto) as this;
    }

    public get name() {
        return this.dto.name;
    }

    public get value() {
        return this.dto.value === '1';
    }
}
